import React from 'react';
import {IfmsRoute} from '../../../config/types';


export const AiMawbView = React.lazy(() => import('../mawb/AiMawbView'));
export const AiHawbView = React.lazy(() => import('../hawb/AiHawbView'));
const AiQuotationView = React.lazy(() => import('../../airImport/quotation/AiQuotationView'));
const AiMawbBillingsView = React.lazy(() => import('../mawb/AiMBillingsView'));
const AiHawbBillingsView = React.lazy(() => import('../hawb/AiHBillingsView'));
const MblArrivalNoticeView = React.lazy(() => import('../../reports/MblArrivalNoticeView'));
const CorrectionNoticeView = React.lazy(() => import('../../reports/CorrectionNoticeView'));
const IRC225View = React.lazy(() => import('../../reports/IRC225View'));
const HblArrivalNoticeView = React.lazy(() => import('../../reports/HblArrivalNoticeView'));
const DeliveryOrderView = React.lazy(() => import('../../reports/DeliveryOrderView'));
const ItTeNoticeView = React.lazy(() => import ('../../reports/ItTeNoticeView'));
const PackageLabelView = React.lazy(() => import('../../reports/PackageLabelView'));
const PreliminaryClaimNoticeView = React.lazy(() => import('../../reports/PreliminaryClaimNoticeView'));
const ProofOfDeliveryView = React.lazy(() => import('../../reports/ProofOfDeliveryView'));
const ReleaseOrderTurnoverView = React.lazy(() => import('../../reports/ReleaseOrderTurnoverView'));
const StraightBlView = React.lazy(() => import('../../reports/StraightBlView'));
const MemoListView = React.lazy(() => import('../../reports/MemoListView'));
const CargoManifestStatusView = React.lazy(() => import('../../reports/CargoManifestStatusView'));
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView'));
const ProfitAndVolumeSummaryView =  React.lazy(() => import('../../common/reports/ProfitAndVolumeSummaryView')); 
const PreAlertView = React.lazy(() => import('../reports/PreAlertView'));
const FolderLabelView = React.lazy(() => import('../../reports/FolderLabelView'));
const DownloadView = React.lazy(() => import('../../common/DownloadView'));

const routes: Array<IfmsRoute> = [
  { path: '/airImport/mawb/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: AiMawbView },
  { path: '/airImport/hawb/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: AiHawbView },
  { path: '/airImport/quotation/:mode/:id?', component: AiQuotationView },
  { path: '/airImport/viewBillings/mawb/:id?', component: AiMawbBillingsView },
  { path: '/airImport/viewBillings/hawb/:id?', component: AiHawbBillingsView },
  { path: '/airImport/estProfit', component: ProfitAndVolumeSummaryView },
  { path: '/airImport/preAlert', component: PreAlertView },

  //AIM MoreMenu
  { path: '/airImport/arrivalNotice', component: MblArrivalNoticeView },
  { path: '/airImport/AuthorityToMakeEntry', component: MblArrivalNoticeView },
  { path: '/airImport/correctionNotice', component: CorrectionNoticeView },
  { path: '/airImport/IRC225', component: IRC225View },
  { path: '/airImport/folderLabel', component: FolderLabelView },

  //AIH MoreMenu
  { path: '/airImport/hblArrivalNotice', component: HblArrivalNoticeView },
  { path: '/airImport/shortDeliveryOrder', component: DeliveryOrderView },
  { path: '/airImport/preDeliveryOrder', component: DeliveryOrderView },
  { path: '/airImport/ItTeNotice', component: ItTeNoticeView },
  { path: '/airImport/packageLabel', component: PackageLabelView },
  { path: '/airImport/preliminaryClaimNotice', component: PreliminaryClaimNoticeView },
  { path: '/airImport/proofOfDelivery', component: ProofOfDeliveryView },
  { path: '/airImport/releaseOrderTurnover', component: ReleaseOrderTurnoverView },
  { path: '/airImport/straightBl', component: StraightBlView },
  { path: '/airImport/memoCustomerList', component: MemoListView },

  //common MoreMenu
  { path: '/airImport/correctionNotice', component: CorrectionNoticeView },
  { path: '/airImport/memoList', component: MemoListView },
  { path: '/airImport/cargoManifestStatus', component: CargoManifestStatusView },
  { path: '/airImport/pickupDelivery', component: PickupDeliveryView },

  //Download
  { path: '/airImport/download/:jobName?/:id?', component: DownloadView },
];

export default routes;
